export const UNIT_INCHES = 'in';
export const UNIT_CENTIMETERS = 'cm';
